import React from 'react';

import * as S from './styles';

export type PlaceholderVariant = 'A' | 'B' | 'C';

type PlaceholderRowProps = {
  icon: string;
  variant: PlaceholderVariant;
  isAlert?: boolean;
};

type CSSWidth = string;

const variantWidths: { [V in PlaceholderVariant]: [CSSWidth, CSSWidth] } = {
  A: ['60%', '50%'],
  B: ['55%', '30%'],
  C: ['40%', '50%'],
};

type PriceChangeStyling = { isPositive: boolean; width: CSSWidth };
const variantPriceChange: { [V in PlaceholderVariant]: PriceChangeStyling } = {
  A: { isPositive: true, width: '14%' },
  B: { isPositive: true, width: '11%' },
  C: { isPositive: false, width: '10%' },
};

const PlaceholderRow = ({ icon, variant, isAlert }: PlaceholderRowProps) => {
  const lineOfTextWidths = variantWidths[variant];
  const priceChangeStyling = variantPriceChange[variant];

  return (
    <S.ItemRow>
      <S.Icon>
        <S.Image alt="" src={icon} />
      </S.Icon>
      <S.PlaceholderInfo>
        <S.PlaceHolderLineOfText style={{ width: lineOfTextWidths[0] }} />
        {isAlert && (
          <S.PlaceHolderPriceChange
            isPositive={priceChangeStyling.isPositive}
            style={{ width: priceChangeStyling.width }}
          />
        )}
        <S.PlaceHolderLineOfText style={{ width: lineOfTextWidths[1] }} />
      </S.PlaceholderInfo>
    </S.ItemRow>
  );
};

export default PlaceholderRow;
